import { render, staticRenderFns } from "./TwoLinks.vue?vue&type=template&id=14b0e9f4&"
import script from "./TwoLinks.vue?vue&type=script&lang=js&"
export * from "./TwoLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports